<template>
    <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            background
            layout="total, prev, pager, next,sizes,jumper"
            :page-size="size"
            :page-sizes="[10,200, 500, 1000, 5000, 10000]"
            :total="total"
            style="margin:10px 0 0 10px;">
    </el-pagination>
</template>

<script>
    export default {
        name: "CustomPagination",
        props:['size','total'],
        methods:{
            handleCurrentChange(val){
                this.$emit('current-change',{pageNo:val},'tableParams')
            },
            handleSizeChange(val){
                this.$emit('size-change',{pageSize:val},'tableParams')
            }
        }
    }
</script>

<style scoped>

</style>